import { useRef, useState } from "react";
import MentiAvatar from "./components/MentiAvatar/MentiAvatar";

type Status =
    | "idle"
    | "listening"
    | "processing"
    | "speaking";

export default function MentiLipSyncTest() {
    const audioRef =
        useRef<HTMLAudioElement | null>(null);

    const [audioElement, setAudioElement] =
        useState<HTMLAudioElement | null>(null);

    const [status, setStatus] =
        useState<Status>("idle");

    const handlePlay = async () => {
        if (!audioRef.current) return;

        try {
            await audioRef.current.play();

            setStatus("speaking");
        } catch (error) {
            console.error(
                "Audio playback failed:",
                error
            );
        }
    };

    const handlePause = () => {
        if (!audioRef.current) return;

        audioRef.current.pause();

        setStatus("idle");
    };

    const handleEnded = () => {
        setStatus("idle");
    };

    return (
        <div
            style={{
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 20,
                padding: 20,
                background:
                    "#07111f",
            }}
        >

            <h2
                style={{
                    color: "white",
                    margin: 0,
                }}
            >
                Menti Lip Sync Test
            </h2>


            {/* Menti */}

            <MentiAvatar
                audioElement={audioElement}
                status={status}
            />


            {/* Audio */}

            <audio
                ref={(element) => {
                    audioRef.current = element;
                    setAudioElement(element);
                }}
                src="/menti/menti.wav"
                preload="auto"
                onEnded={handleEnded}
            />


            {/* Controls */}

            <div
                style={{
                    display: "flex",
                    gap: 12,
                }}
            >

                <button
                    onClick={handlePlay}
                    style={{
                        padding:
                            "10px 20px",
                        border: "none",
                        borderRadius: 8,
                        cursor: "pointer",
                    }}
                >
                    ▶ Play Menti
                </button>


                <button
                    onClick={handlePause}
                    style={{
                        padding:
                            "10px 20px",
                        border: "none",
                        borderRadius: 8,
                        cursor: "pointer",
                    }}
                >
                    ⏸ Pause
                </button>

            </div>


            {/* Status */}

            <div
                style={{
                    color: "#8eeaff",
                    fontSize: 14,
                }}
            >
                Status: {status}
            </div>

        </div>
    );
}

